import { useRestaurantSettings } from '../../../hooks/useRestaurantSettings';
import { formatTelHref } from '../../../helpers/phone';
import './phonecta.scss';

const View = ({ data, isEditMode }: any) => {
  const settings = useRestaurantSettings();

  const eyebrow = data.eyebrow || 'Réserver';
  const heading =
    data.heading || 'Une table, un dîner, un déjeuner d’affaires.';
  const description =
    data.description ||
    'Composez l’un des deux numéros — nous vous proposons une table à votre convenance.';

  return (
    <section className="phone-cta">
      <div className="shell">
        <div className="phone-block">
          <div>
            <p className="eyebrow">{eyebrow}</p>
            <h2>{heading}</h2>
            <p>{description}</p>
            <div className="phone-numbers">
              {settings.phone_primary && (
                <a
                  href={formatTelHref(settings.phone_primary)}
                  aria-label={`Ligne fixe : ${settings.phone_primary}`}
                >
                  {settings.phone_primary}
                </a>
              )}
              {settings.phone_secondary && (
                <a
                  href={formatTelHref(settings.phone_secondary)}
                  aria-label={`Mobile : ${settings.phone_secondary}`}
                >
                  {settings.phone_secondary}
                </a>
              )}
            </div>
          </div>
          <div>
            {settings.phone_primary && (
              <a
                href={formatTelHref(settings.phone_primary)}
                className="btn btn-secondary"
              >
                <span aria-hidden="true">☎</span>
                Appeler maintenant
              </a>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default View;
